import {GET, POST} from "@/services/gateway";

const listClassrooms = ({pagination, search, filter}) => {
  return POST('google/seat/classroom/list', {pagination, search, filter});
}

const getClassroomDetails = (id) => {
  return GET('google/classroom/classroom', {id})
}

const listSnapshots = ({classroomId, date, dateTo}) => {
  return POST('google/classroom/snapshot/list', {classroomId, date, dateTo})
}

const createBackup = (classroomId) => {
  return GET('google/classroom/backup', {classroomId})
}

const exportSnapshot = ({snapshotDateTime, sourceIds, searchTerm, snapshotId, selectedIds, code}) => {
  return POST('google/classroom/wholeclass/export', {
    snapshotDateTime,
    sourceIds,
    searchTerm,
    snapshotId,
    selectedIds
  }, {code: code ? code : null})
}

const restoreSnapshot = ({
                           snapshotDateTime,
                           sourceIds,
                           searchTerm,
                           destinationId,
                           snapshotId,
                           selectedIds,
                           RestoreType,
                           code
                         }) => {
  return POST('google/classroom/wholeclass/restore', {
    snapshotDateTime,
    sourceIds,
    searchTerm,
    destinationId,
    snapshotId,
    selectedIds,
    RestoreType
  }, {code: code ? code : null});
}

export {
  listClassrooms,
  getClassroomDetails,
  createBackup,
  listSnapshots,
  exportSnapshot,
  restoreSnapshot
}
